<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('user.upload_modal.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
    >
        <template #footer>
            <a-button
                key="submit"
                type="primary"
                data-cy="user-import-submit"
                :loading="processing"
                :disabled="fileList.length == 0"
                @click="handleSubmit"
            >
                {{ $t('user.upload_modal.submit') }}
            </a-button>
        </template>
        <a-upload-dragger
            name="file"
            data-cy="user-import-drag"
            @remove="handleRemove"
            :file-list="fileList"
            :multiple="true"
            :before-upload="beforeUpload"
        >
            <p class="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p class="ant-upload-text">{{ $t('user.upload_modal.body') }}</p>
            <p class="ant-upload-hint">{{ $t('user.upload_modal.hint') }}</p>
        </a-upload-dragger>
        <ui-checkbox data-cy="user-import-upload-for-reactivation" class="mt-2" v-model="is_reactivation">
            {{ $t('user.upload_modal.is_reactivation') }}
        </ui-checkbox>
    </a-modal>
</template>

<script>
import UiCheckbox from '@/components/ui/Checkbox.vue';
import { InboxOutlined } from '@ant-design/icons-vue';

export default {
    components: { UiCheckbox, InboxOutlined },
    data() {
        return {
            modal_visible: false,
            is_reactivation: null,
            fileList: [],
            fileLimit: -3,
        };
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        showModal() {
            this.fileList = [];
            this.is_reactivation = null;
            this.modal_visible = true;
        },
        hideModal() {
            this.modal_visible = false;
        },
        handleSubmit() {
            const { fileList } = this;
            const formData = new FormData();
            fileList.forEach((file) => {
                formData.append('files[]', file);
            });

            if (this.is_reactivation) {
                formData.append('is_reactivation', true);
            }

            this.$emit('formSubmit', formData);
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            const isCSV = file.type === 'text/csv';
            const isXSL = file.type === 'application/vnd.ms-excel';
            const isXSLX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            if (isCSV || isXSL || isXSLX) {
                if (this.fileList.some((value) => value.name.toLowerCase() == file.name.toLowerCase())) {
                    this.$notification.error({
                        message: this.$t('validation.exists_already', { attribute: 'file' }),
                    });
                } else {
                    this.fileList = [...this.fileList, file].slice(this.fileLimit);
                }
            } else {
                this.$notification.error({
                    message: this.$t('validation.mimes', { attribute: 'File', values: 'CSV, XSL or XSLX' }),
                });
            }
            return false;
        },
    },
};
</script>
